"use strict";
// or `document.querySelector()` for any selector
// var player = new MediaElement('video-player', {
//     success: function(mediaElement, originalNode) {
//         // do things
//     }
// });

$(document).on("click", "#video-poster", function () {
  var height = ($(window).width() * 9) / 16;
  if (height > 360) {
    height = 360;
  }
  // $("#video-player_youtube_iframe").css('height',height);
  // $(".video-player").show();
  // player.play();
  $(this).hide();
});

//check vào tạo cookie hiện popup
var firstTimeVisit = getCookie("first_time_visit_today");
if (firstTimeVisit == null || firstTimeVisit == 0) {
  $("#open-featured-popup-0").click();
  setCookie("first_time_visit_today", 1, 1);
}

//mở rộng ô khóa học -> di động
function expandCourses() {
  // console.log('xem thêm khóa học mobile');
  $(".mobile-content").css("height", "auto");
  $(".view-more-courses").css("display", "none");
}

// người dùng click vào slider
function pressClick(id) {
  $("#" + id).click();
}

// fancybox cho video và popup
$(".fancybox").fancybox({ type: "iframe" });

//

$(document).on("click", ".denwa-button", function () {
  $("#denwa-modal").fadeIn();
});

function ValidateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
}

var denwaForm = new Vue({
  el: "#denwa-modal",
  data: {
    acceptTerm: false,
    name: "",
    phone1: "",
    phone2: "",
    phone3: "",
    timeCare: "",
    message: "",
    isError: false,
    isSuccess: false,
  },
  methods: {
    closeModal: function () {
      $("#denwa-modal").fadeOut();
    },
    endPhone: function (event) {
      var id = event.target.getAttribute("data-no");
      if (event.target.value.length >= 4 && id < 3) {
        this.$refs["phone-" + (parseInt(id) + 1)].focus();
      }
    },
    submit: function () {
      var _self = this;
      _self.isError = false;
      if (!_self.acceptTerm) {
        return false;
      }
      var phone = _self.phone1 + "-" + _self.phone2 + "-" + _self.phone3;
      // Validate
      if (
        _self.name == "" ||
        _self.phone1 == "" ||
        _self.phone2 == "" ||
        _self.phone3 == "" ||
        _self.timeCare == "" ||
        _self.message == ""
      ) {
        return (_self.isError = true);
      }
      $.ajax({
        type: "post",
        url: "/contact/denwa",
        dataType: "JSON",
        async: true,
        data: {
          name: _self.name,
          phone: phone,
          time_care: _self.timeCare,
          message: _self.message,
        },
        success: function (response) {
          console.log(response);
          _self.isSuccess = true;
          _self.name = "";
          _self.phone1 = "";
          _self.phone2 = "";
          _self.phone3 = "";
          _self.timeCare = "";
          _self.message = "";
        },
        error: function (error) {
          console.log(error);
        },
      });
    },
  },
});

// student feedback slick
var numOfSliders = 3;
if (screen.width < 800) numOfSliders = 1;
// $('.student-feedback-slider').slick({
// 	slidesToShow: numOfSliders,
// 	slidesToScroll: 1,
// 	autoplay: true,
// 	autoplaySpeed: 3000,
// });
$(".home-popup").fancybox();
